import React from "react";
import { Avatar } from "@mui/material";
import StyledAvatarPicker from "./style";
import AddIcon from "@mui/icons-material/Add";

import useFilePicker from "../../hooks/useFilePicker";

const AvatarPicker = ({
  alt,
  image,
  size = 120,
  onPick,
  onPickError,
  iconSize = 40,
}) => {
  const { openFilePicker, filesContent, loading } = useFilePicker(
    onPick,
    onPickError
  );

  return (
    <StyledAvatarPicker onClick={openFilePicker}>
      <Avatar alt={alt} src={image} sx={{ width: size, height: size }} />
      <div className="icon-container">
        <div
          className="icon-background"
          style={{ width: iconSize, height: iconSize }}
        >
          <AddIcon sx={{ width: iconSize, height: iconSize }} color="info" />
        </div>
      </div>
    </StyledAvatarPicker>
  );
};

export default AvatarPicker;
